import script from "./WelcomeName.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeName.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeName.vue?vue&type=style&index=0&id=2c4c401c&lang=css"

const __exports__ = script;

export default __exports__